// w14.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W14 = () => {
  return <WW config={pageConfigs.w14} />;
};

export default W14;
